import { StringConstants } from "global/constants/StringConstants";

class UrlConstants extends StringConstants {
  PROD = false;

  url_prod = "https://services.softsages.com/";
  url_dev = "https://api-uat.softsages.com/";
  // url_dev = "http://localhost:6030/";
  
  url = (this.PROD ? this.url_prod : this.url_dev) + "crm";
  url_core =
    (this.PROD
      ? this.url_prod
      : this.url_dev.includes("uat")
      ? this.url_dev
      : "http://localhost:6040/") + "core";

  mailzzy = "mailzzy";

  // Base Folders
  public = "public";
  secure = "secure";
  multiFactor = "multiFactor";
  restricted = "restricted";
  user = "user";
  document = "document";
  contact = "contact";
  campaign = "campaign";
  social = "social";
  groups = "group";
  group = "group";
  tag = "tag";
  search = "search";
  count = "count";

  //Permissions
  SELF = "self";
  GET = "fetch";
  ADD = "add";
  UPDATE = "update";
  UPLOAD = "upload";
  DELETE = "delete";
  APP = "mailzzy";

  //NOTIFICATION
  GET_NOTIFICATION = `${this.url}/${this.secure}/${this.notification}/${this.web}/${this.fetchPermission}/all`;
  DELETE_NOTIFICATION = `${this.url}/${this.secure}/${this.notification}/${this.web}/${this.deletePermission}`;
  DELETE_ALL_NOTIFICATION = `${this.url}/${this.secure}/${this.notification}/${this.web}/${this.deletePermission}/all`;
  MARK_AS_READ = `${this.url}/${this.secure}/${this.notification}/${this.web}/read`;
  MARK_AS_READ_ALL = `${this.url}/${this.secure}/${this.notification}/${this.web}/read/all`;
  GET_NOTIFICATION_COUNT = `${this.url}/${this.secure}/${this.notification}/${this.web}/${this.fetchPermission}`;

  DELETE_DOCUMENT = `${this.url}/${this.secure}/${this.document}/${this.deletePermission}`;
  DOCUMENTS = `${this.url}/${this.secure}/documents/owner`;

  // USERS
  GET_APP_USERS = `${this.url}/internal/users/limit`;
  GET_APP_USERS_COUNT = `${this.url}/internal/users/count`;
  GET_EXTERNAL_USERS = `${this.url}/external/users/limit`;
  GET_EXTERNAL_USERS_COUNT = `${this.url}/external/users/count`;
  ADD_USER = `${this.url}/${this.secure}/${this.user}/${this.addPermission}`;
  UPDATE_USER = `${this.url_core}/${this.secure}/${this.user}/${this.updatePermission}`;
  UPDATE_PROFILE_PICTURE = `${this.url}/${this.secure}/${this.user}/profile/picture/${this.updatePermission}`;
  REMOVE_PROFILE_PICTURE = `${this.url}/${this.secure}/${this.user}/profile/picture/remove`;
  SAVE_PREFERENCES = `${this.url_core}/${this.secure}/${this.user}/preferences/update`;
  RESET_MFA = `${this.url_core}/mfa/disable/email`;
  UNLOCK_USER = `${this.url_core}/unlock/user/email`;
  RESET_INACTIVE_USER_EMAIL_COUNT = `${this.url}/${this.campaigner}/${this.updatePermission}/count/userId`;
  MARKERING_SUBSCRIBER = `${this.url_core}/public/marketing/subscriber/${this.addPermission}`;

  //SESSION
  GET_USER_SESSIONS = `${this.url_core}/${this.secure}/${this.user}/fetch/active/sessions`;
  INACTIVATE_SESSION = `${this.url_core}/${this.secure}/${this.user}/inactivate/session`;

  // ROLES MANAGEMENT
  GET_RESOURCES_BY_DOMAIN = `${this.url_core}/${this.secure}/${this.user}/resources`;
  GET_USER_PROFILE = `${this.url_core}/${this.secure}/${this.user}/email`;
  GET_ROLES_BY_DOMAIN = `${this.url_core}/roles`;
  GET_ROLES_BY_DOMAIN_COUNT = `${this.url_core}/roles/count`;
  GET_ROLES_SEARCH = `${this.url_core}/roles/search`;
  GET_ROLES_SEARCH_COUNT = `${this.url_core}/roles/count/search`;
  ADD_ROLE = `${this.url_core}/role/${this.addPermission}`;
  UPDATE_ROLE = `${this.url_core}/role/${this.updatePermission}`;

  // SECURITY
  GET_QR_CODE = `${this.url_core}/${this.secure}/multiFactor/${this.fetchPermission}/qrCode`;
  GET_SECRET_KEY = `${this.url_core}/${this.secure}/multiFactor/${this.fetchPermission}/secretKey`;
  VERIFY_MFA = `${this.url_core}/${this.secure}/${this.updatePermission}/mfa`;
  VERIFY_TOTP = `${this.url_core}/${this.public}/totp/verify`;

  //ADD LOCATION
  ADD_LOCATION = `${this.url}/location/${this.addPermission}`;

  // Mailzzy
  PUBLIC_URI_PATH_TOKEN = `${this.url_core}/public`;
  SECURE_URI_PATH_TOKEN = `${this.url_core}/secure`;
  RESTRICTED_URI_PATH_TOKEN = `${this.url_core}/restricted`;
  WORKFLOW_PATH = `${this.url_core}/secure`;
  MULTIFACTOR = "multiFactor";
  CAMPAIGN_URL = `${this.url}/campaign`;
  CAMPAIGNER_URL = `${this.url}/campaigner`;
  CONTACT_URL = `${this.url}/contact`;
  SOCIAL_URL = `${this.url_core}/social`;
  BILLING_URL = `${this.url_core}/billing`;
  SMS_URL = `${this.url_core}/sms`;
  SALESFORCE_URL = `${this.url_core}/salesforce`;
  EXTERNAL_APP_URL = `${this.url_core}/secure/externalApp`;
  SOCIAL_CAMPAIGN_URL = `${this.url}/social`;
  SOCIAL_FETCH_CAMPAIGN_URL = `${this.url}/social/fetch`;
  SENDER_URL = `${this.url}/sender`;
  ABTEST = `abtest`;

  // Auth
  LOGIN = `${this.url_core}/${this.public}/${this.user}/login`;
  REFRESHTOKEN = `${this.url_core}/${this.public}/refresh/token`;
  RESET_PASSWORD = `${this.url_core}/${this.public}/${this.user}/pwd/reset`;
  UPDATE_PASSWORD = `${this.url_core}/${this.restricted}/${this.user}/pwd/${this.updatePermission}`;
  VERIFY_TEMP_PASSWORD = `${this.url_core}/${this.public}/${this.user}/pwd/verify`;
  MFA_GET_QR_CODE = `${this.url_core}/${this.restricted}/${this.multiFactor}/${this.fetchPermission}/qrCode`;
  MFA_GET_PREAUTH_KEY = `${this.RESTRICTED_URI_PATH_TOKEN}/${this.MULTIFACTOR}/${this.GET}/secretKey`;
  ACTIVATE_MFA = `${this.url_core}/${this.restricted}/${this.multiFactor}/enable/mfa`;
  SAVE_FIREBASE_TOKEN = `${this.url}/${this.secure}/${this.user}/save/deviceId`;
  REMOVE_DEVICE_ID = `${this.url}/${this.secure}/${this.user}/remove/deviceId`;
  REGISTER_USER = `${this.url_core}/${this.public}/register`;
  RESEND_ACCOUNT_VERIFICATION_EMAIL = `${this.url_core}/${this.public}/resend/account/verification/email`;
  VIEW_PLANS = `${this.PUBLIC_URI_PATH_TOKEN}/plans/${this.mailzzy}/account`;
  ACTIVATE_USER = `${this.url}/secure/campaigner/activate`;
  VERIFY_TEMP_PWD_ACTIVATE = `${this.PUBLIC_URI_PATH_TOKEN}/user/pwd/verify/activate`;
  IS_MANAGER = `${this.url}/secure/isManager`;
  IS_FIRST_NAME_MANDATORY = `${this.CAMPAIGN_URL}/${this.fetchPermission}/hasMandatory/firstName`;
  campaignRetentionDuration = `${this.CAMPAIGN_URL}/${this.GET}/campaign/retention`;

  //DASHBOARD
  GET_LAST_EXECUTED_CAMPAIGN = `${this.CAMPAIGN_URL}/${this.fetchPermission}/last/executed`;
  GET_TOTAL_ACTIVE_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/active/count`;
  GET_DATE_WISE_CONTACTS_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/subscriber/status`;
  GET_COUNTS_NAME = `${this.CAMPAIGN_URL}/${this.fetchPermission}/count/name`;
  GET_CONTACTS_GRAPH = `${this.CONTACT_URL}/${this.fetchPermission}/subscription/graph/status`;
  GET_EMAIL_SEND = `${this.CAMPAIGN_URL}/${this.fetchPermission}/email/sent`;
  GET_EMAIL_SEND_GRAPH = `${this.CAMPAIGN_URL}/${this.fetchPermission}/email/sent/graph`;
  GET_EMAIL_USAGE_LIMIT = `${this.url}/${this.secure}/account/limit`;

  //CONTACTS
  GET_CONTACT_STATUS_TYPE = `${this.CONTACT_URL}/${this.fetchPermission}/statusType`;
  GET_ALL_CONTACTS_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/count`;
  GET_ARCHIVED_CONTACTS_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/archived/count`;
  GET_ALL_CONTACTS = `${this.CONTACT_URL}/${this.fetchPermission}/list`;
  GET_ARCHIVED_CONTACTS = `${this.CONTACT_URL}/${this.fetchPermission}/archived/list`;
  GET_CONTACT_BY_ID = `${this.CONTACT_URL}/${this.fetchPermission}/id`;
  GET_COLUMN_TYPES = `${this.CONTACT_URL}/${this.uploadPermission}/column/type/csv`;
  EXPORT_CONTACTS = `${this.CONTACT_URL}/${this.fetchPermission}/download/report`;
  GET_ALL_GROUPS_SELECTION = `${this.CONTACT_URL}/${this.fetchPermission}/${this.group}`;
  ADD_SINGLE_CONTACT = `${this.CONTACT_URL}/${this.addPermission}/${this.group}`;
  GET_TAG_BY_CONTACT_ID = `${this.CONTACT_URL}/${this.fetchPermission}/tag/contactId`;
  DELETE_TAG_BY_CONTACT_ID = `${this.CONTACT_URL}/${this.deletePermission}/contactId`;
  UNSUBSCRIBE_CONTACT_BY_ID = `${this.CONTACT_URL}/${this.updatePermission}/contact/status`;
  SUBSCRIBE_CONTACT_BY_ID = `${this.CONTACT_URL}/${this.updatePermission}/reSubscribe/contactId`;
  MULTIPLE_SUBSCRIBE_CONTACT = `${this.CONTACT_URL}/${this.updatePermission}/reSubscribe`;
  uploadContactGroup = `${this.CONTACT_URL}/${this.uploadPermission}/${this.group}/async`;
  GET_GROUPS_COUNT_BY_CONTACT_ID = `${this.CONTACT_URL}/${this.fetchPermission}/count/${this.group}/contactId`;
  GET_GROUPS_BY_CONTACT_ID = `${this.CONTACT_URL}/${this.fetchPermission}/${this.group}/contactId`;
  UPDATE_CONTACT_PROFILE = `${this.CONTACT_URL}/${this.updatePermission}/profile`;
  CAMPAIGN_SEND_TIME = `${this.CONTACT_URL}/${this.fetchPermission}/segment/send/time`;
  SOFT_DELETE_CONTACT = `${this.CONTACT_URL}/${this.deletePermission}/contacts/soft`;
  DELETE_ARCHIVE_CONTACT = `${this.CONTACT_URL}/${this.deletePermission}/archived/contacts`;

  //GROUPS
  GET_ALL_GROUPS_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/groups/count`;
  GET_ALL_FILLED_GROUPS_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/groups/audience/count`;
  GET_ALL_GROUPS = `${this.CONTACT_URL}/${this.fetchPermission}/groups`;
  SEARCH_GROUPS = `${this.CONTACT_URL}/${this.fetchPermission}/${this.search}/${this.group}`;
  SEARCH_GROUPS_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/${this.search}/${this.group}`;
  CONTACT_GROUP_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/${this.count}/groups`;
  CONTACT_SEARCH_GROUP_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/${this.search}/${this.count}/${this.group}`;
  EXPORT_GROUPS = `${this.CONTACT_URL}/${this.fetchPermission}/download/group`;
  DELETE_CONTACT_GROUP = `${this.CONTACT_URL}/delete`;
  UPDATE_CONTACT_GROUP = `${this.CONTACT_URL}/${this.updatePermission}/group`;
  ADD_SINGLE_GROUP = `${this.CONTACT_URL}/${this.addPermission}/${this.group}`;
  GET_CONTACTS_COUNT_BY_SEGMENT_ID = `${this.CONTACT_URL}/${this.fetchPermission}/count/segmentId`;
  GET_CONTACTS_BY_SEGMENT_ID = `${this.CONTACT_URL}/${this.fetchPermission}/segmentId`;

  //TAGS
  GET_ALL_TAGS_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/tags/count`;
  GET_ALL_TAGS = `${this.CONTACT_URL}/${this.fetchPermission}/tags`;
  GET_ALL_FILLED_TAGS_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/tags/audience/count`;
  GET_ALL_FILLED_TAGS = `${this.CONTACT_URL}/${this.fetchPermission}/tags/audience`;
  CONTACT_TAG_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/${this.count}/${this.tag}`;
  CONTACT_SEARCH_TAG_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/${this.search}/${this.count}/${this.tag}`;
  DELETE_TAGS = `${this.CONTACT_URL}/delete`;
  ADD_UPDATE_TAG = `${this.CONTACT_URL}/${this.updatePermission}/${this.tag}/contactId`;
  DELETE_SINGLE_CONATCT_FROM_TAG = `${this.CONTACT_URL}/delete/contactId`;

  // Templates Page API
  getCampaignTemplates = `${this.url}/secure/email/custom/templates`;
  addCampaignTemplate = `${this.url}/secure/email/custom/template/${this.addPermission}`;
  updateCampaignTemplate = `${this.url}/secure/email/custom/template/${this.updatePermission}`;
  updateCampaignTemplatePermission = `${this.url}/secure/email/custom/template/category/${this.updatePermission}`;
  deleteCampaignTemplate = `${this.url}/secure/email/custom/template/${this.deletePermission}`;
  getCampaignTemplateById = `${this.url}/secure/email/custom/template`;
  getDefaultFooterTemplate = `${this.url}/secure/email/template/default/${this.fetchPermission}`;

  // User API
  campaigners = `${this.CAMPAIGNER_URL}/${this.fetchPermission}/page`;
  getEmailCountById = `${this.url}/secure/userId`;
  getCampaignerById = `${this.CAMPAIGNER_URL}/${this.fetchPermission}/email`;
  campaignersReport = `${this.CAMPAIGNER_URL}/${this.fetchPermission}/download/report`;
  campaignersCount = `${this.CAMPAIGNER_URL}/${this.fetchPermission}/count`;
  addCampaigner = `${this.CAMPAIGNER_URL}/${this.addPermission}`;
  updateCampaigner = `${this.CAMPAIGNER_URL}/${this.updatePermission}`;
  updateCampaignerRole = `${this.url_core}/${this.secure}/${this.user}/role/${this.updatePermission}`;
  updateCampaignerStatus = `${this.url_core}/${this.updatePermission}/user/id`;
  userSearch = `${this.CAMPAIGNER_URL}/${this.fetchPermission}/search/page`;
  userSearchCount = `${this.CAMPAIGNER_URL}/${this.fetchPermission}/search/page`;
  activeCampaigner = `${this.CAMPAIGNER_URL}/${this.fetchPermission}/active`;
  unlockUser = `${this.url_core}/unlock/user/email`;
  disableMFA = `${this.url_core}/mfa/disable/email`;
  userEmail = `${this.SECURE_URI_PATH_TOKEN}/user/email`;

  SELF_CAMPAIGNER = `${this.CAMPAIGNER_URL}/${this.fetchPermission}/self`;

  // SENDERS
  GET_ALL_SENDERS_COUNT = `${this.SENDER_URL}/${this.fetchPermission}/count`;
  GET_SENDERS = `${this.SENDER_URL}/${this.fetchPermission}/page`;
  ADD_SENDER = `${this.SENDER_URL}/${this.addPermission}`;
  UPDATE_SENDER = `${this.SENDER_URL}/${this.updatePermission}`;
  DELETE_SENDER = `${this.SENDER_URL}/${this.deletePermission}/id`;
  VERIFY_SENDER = `${this.SENDER_URL}/${this.fetchPermission}/id`;
  RESEND_VERIFICTION_CODE_SENDER = `${this.SENDER_URL}/${this.fetchPermission}/id`;
  GET_ALL_SENDERS = `${this.SENDER_URL}/${this.fetchPermission}/details`;

  // Custom Domains
  fetchCustomDomains = `${this.url_core}/domains`;
  addCustomDomain = `${this.url_core}/add/domain`;
  getDomainDetails = `${this.url_core}/dns/domain`;
  sendVerificationDetails = `${this.url_core}/send/verification/details/domain`;
  uploadDocumnet = `${this.url_core}/document/upload/owner`;

  //Billing-Usage Page API
  getPaymentMethods = `${this.BILLING_URL}/${this.fetchPermission}/paymentMethod`;
  getCardDetail = `${this.BILLING_URL}/${this.fetchPermission}/paymentMethod`;
  deleteCard = `${this.BILLING_URL}/${this.deletePermission}/paymentMethod`;
  addCard = `${this.BILLING_URL}/${this.addPermission}/paymentMethod`;
  setPrimaryCard = `${this.BILLING_URL}/${this.updatePermission}/paymentMethod`;
  changePlan = `${this.BILLING_URL}/${this.addPermission}/paidCustomer`;
  updatePlan = `${this.BILLING_URL}/${this.updatePermission}/plan`;
  cancelSubscription = `${this.BILLING_URL}/${this.deletePermission}/subscription`;
  isActiveCancelSubscription = `${this.BILLING_URL}/${this.fetchPermission}/subscription/status`;
  featurePlan = `${this.PUBLIC_URI_PATH_TOKEN}/plan/account`;
  getPlanDetail = `${this.BILLING_URL}/${this.fetchPermission}/planLimit`;
  getInvoiceDetail = `${this.BILLING_URL}/${this.fetchPermission}/invoice`;
  getInvoiceCount = `${this.BILLING_URL}/${this.fetchPermission}/count`;
  getDailyEmailCount = `${this.CAMPAIGN_URL}/${this.fetchPermission}/emailCount`;
  viewPlans = `${this.PUBLIC_URI_PATH_TOKEN}/plans/mailzzy/account`;
  newPlans = `${this.PUBLIC_URI_PATH_TOKEN}/plans/mailzzy/customised`;
  customPlan = `${this.SECURE_URI_PATH_TOKEN}/custom/plans`;

  GET_ROLES = `${this.url_core}/roles`;
  GET_USERS_ROLES = `${this.SECURE_URI_PATH_TOKEN}/user/roles`;
  GET_ROLES_COUNT = `${this.url_core}/roles/count`;
  GET_RESOURCES = `${this.SECURE_URI_PATH_TOKEN}/user/resources`;

  // Tickets
  ASSIGNED = `${this.WORKFLOW_PATH}/workflow/tasks/my/assigned`;
  ASSIGNED_COUNT = `${this.WORKFLOW_PATH}/workflow/tasks/my/assigned/count`;
  ASSIGNED_SEARCH_DATA = `${this.WORKFLOW_PATH}/workflow/tasks/my/assigned/search`;
  ASSIGNED_SEARCH_COUNT = `${this.WORKFLOW_PATH}/workflow/tasks/my/assigned/search/count`;
  RAISED = `${this.WORKFLOW_PATH}/workflow/tasks/my`;
  RAISED_COUNT = `${this.WORKFLOW_PATH}/workflow/tasks/my/count`;
  RAISED_SEARCH_DATA = `${this.WORKFLOW_PATH}/workflow/tasks/my/search`;
  RAISED_SEARCH_COUNT = `${this.WORKFLOW_PATH}/workflow/tasks/my/search/count`;
  COMPLETED = `${this.WORKFLOW_PATH}/workflow/tasks/status/completed`;
  COMPLETED_COUNT = `${this.WORKFLOW_PATH}/workflow/tasks/status/completed/count`;
  COMPLETED_SEARCH_DATA = `${this.WORKFLOW_PATH}/workflow/tasks/status/completed/search`;
  COMPLETED_SEARCH_COUNT = `${this.WORKFLOW_PATH}/workflow/tasks/status/completed/search/count`;
  OPEN = `${this.WORKFLOW_PATH}/workflow/tasks/status/open`;
  OPEN_COUNT = `${this.WORKFLOW_PATH}/workflow/tasks/status/open/count`;
  OPEN_SEARCH_DATA = `${this.WORKFLOW_PATH}/workflow/tasks/search`;
  OPEN_SEARCH_COUNT = `${this.WORKFLOW_PATH}/workflow/tasks/search/count`;
  UPDATE_TASK = `${this.WORKFLOW_PATH}/workflow/task/update`;
  COMPLETE = `${this.WORKFLOW_PATH}/workflow/task/complete`;
  ASSIGNEE_GROUP_NAME = `${this.WORKFLOW_PATH}/workflow/task/group`;
  ASSIGNEE = `${this.WORKFLOW_PATH}/workflow/task/assign`;
  VIEW_FILE = `${this.WORKFLOW_PATH}/document/view`;
  DOWNLOAD_FILE = `${this.WORKFLOW_PATH}/document/download`;
  PROCESS_ADMIN = `${this.WORKFLOW_PATH}/workflow/isProcessAdmin`;
  FETCH_TICKETS_METRICS = `${this.WORKFLOW_PATH}/tickets/my/metrics`;
  TICKETS_BY_STATUS = `${this.WORKFLOW_PATH}/tickets/my/status`;
  TICKET_BY_ID = `${this.WORKFLOW_PATH}/workflow/task`;
  UPLOAD_TICKET_FILE = `${this.WORKFLOW_PATH}/ticket/document/upload/ticketId`;
  ADD_TICKET_COMMENT = `${this.WORKFLOW_PATH}/task/comment/add`;
  processDefinitions = `${this.SECURE_URI_PATH_TOKEN}/workflow/process/def`;
  addSuportTicket = `${this.SECURE_URI_PATH_TOKEN}/ticket/add`;
  DELETE_TICKET_DOCUMENT = `${this.SECURE_URI_PATH_TOKEN}/ticket/document/delete`;

  // Facebook Integration API
  userAuthenticated = `${this.SOCIAL_URL}/${this.GET}/fb/accessToken`;
  getFaceBookUserDetail = `${this.EXTERNAL_APP_URL}/secrets`;
  getPageFeeds = `${this.SOCIAL_URL}/${this.GET}/fb/feed`;
  deletePageFeed = `${this.SOCIAL_URL}/fb/feed/${this.DELETE}`;
  postFacebookFeed = `${this.SOCIAL_URL}/fb/feed/${this.ADD}`;
  sendSocialCampaign = `${this.SOCIAL_CAMPAIGN_URL}/add/submit`;
  updateFacebookFeed = `${this.SOCIAL_URL}/fb/feed/${this.UPDATE}`;
  uploadImageFacebook = `${this.SECURE_URI_PATH_TOKEN}/${this.UPLOAD}/media`;
  uploadFeedWithImage = `${this.SOCIAL_URL}/fb/image/${this.ADD}`;
  getIntegratedAppNames = `${this.EXTERNAL_APP_URL}/integrated`;
  socialCampaignNameCheck = `${this.SOCIAL_CAMPAIGN_URL}/add/validate`;
  deleteUnexecutedSocialCampaigns = `${this.SOCIAL_CAMPAIGN_URL}/${this.DELETE}`;
  disconnectIntegratedApp = `${this.url_core}/secure/delete/externalApp/secrets`;

  //Reports
  GET_ALL_RECIPIENT_COUNT = `${this.url}/campaign/${this.fetchPermission}/domain/report/count`;
  GET_ALL_RECIPIENT = `${this.url}/campaign/${this.fetchPermission}/domain/report`;
  GET_ALL_FAILED_STATUS_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/response`;
  GET_ALL_FAILED_STATUS = `${this.CONTACT_URL}/${this.fetchPermission}/response`;
  GET_FAILED_BONUS_NAME = `${this.CONTACT_URL}/${this.fetchPermission}/fail/response/name`;

  // Common
  GET_SUBORDINATES = `${this.url}/${this.secure}/subordinates/details`;

  // AI APIs
  SPAM_CHECK = `${this.url}/secure/ai/email/spam/prediction`;
  SUBJECT_LINE_GENERATION = `${this.url}/secure/ai/email/subjectLines`;

  // Campaigns API
  RECIPIENT_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/segmentType`;
  SUBMIT_REGULAR_CAMPAIGN = `${this.url}/${this.campaign}/${this.addPermission}/submit`;
  UPDATE_REGULAR_CAMPAIGN = `${this.url}/${this.campaign}/update/edit`;
  SUBMIT_RETARGET_AUDIENCE_REGULAR_CAMPAIGN = `${this.url}/${this.campaign}/${this.addPermission}/submit/retarget`;
  SUBMIT_SEQUENTIAL_CAMPAIGN = `${this.url}/${this.campaign}/${this.addPermission}/sequential/submit`;
  TEST_REGULAR_CAMPAIGN = `${this.url}/${this.secure}/${this.campaign}/${this.selfPermission}`;
  SUBMIT_AB_CAMPAIGN = `${this.url}/${this.campaign}/abtest/${this.addPermission}/submit`;
  DRAFT_AB_CAMPAIGN = `${this.url}/${this.campaign}/abtest/${this.addPermission}/draft`;
  DRAFT_REGULAR_CAMPAIGN = `${this.url}/${this.campaign}/${this.addPermission}/draft`;
  FETCH_APPROVED_DOMAINS = `${this.url}/secure/email/custom/domains`;
  CAMPAIGNS_LIST = `${this.url}/${this.campaign}/${this.fetchPermission}/page`;
  CAMPAIGNS_LIST_COUNT = `${this.url}/${this.campaign}/${this.fetchPermission}/count`;
  SOCIAL_CAMPAIGNS_LIST = `${this.url}/${this.social}/${this.fetchPermission}/page`;
  SOCIAL_CAMPAIGNS_LIST_COUNT = `${this.url}/${this.social}/${this.fetchPermission}/count`;
  VIEW_EMAIL_CAMPAIGN_CONTENT = `${this.url}/${this.campaign}/${this.fetchPermission}/content`;
  VIEW_EMAIL_LINK_ACTIVITY = `${this.CONTACT_URL}/${this.fetchPermission}/response/action/details`;
  FULL_CAMPAIGN_DETAILS = `${this.url}/${this.campaign}/${this.fetchPermission}/id`;
  FULL_AB_CAMPAIGN_DETAILS = `${this.url}/${this.campaign}/abtest/${this.fetchPermission}/parentId`;
  CHILD_CAMPAIGN_DETAILS = `${this.url}/${this.campaign}/${this.fetchPermission}/child/id`;
  FETCH_FAILED_RESPONSE = `${this.CONTACT_URL}/${this.fetchPermission}/fail/response-and-action-count`;
  RENAME_CAMPAIGN = `${this.url}/${this.campaign}/${this.updatePermission}/id`;
  DELETE_CAMPAIGN = `${this.url}/${this.campaign}/${this.deletePermission}/id`;
  OPEN_CLICK_LIST = `${this.CONTACT_URL}/${this.fetchPermission}/response/${this.campaign}`;
  OPEN_CLICK_LIST_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/response/count/${this.campaign}`;
  FAILED_LIST_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/fail/response/count/${this.campaign}`;
  FAILED_LIST = `${this.CONTACT_URL}/${this.fetchPermission}/fail/response/${this.campaign}`;
  FETCH_FAILED_RESPONSE_COUNT = `${this.CONTACT_URL}/${this.fetchPermission}/fail/response/count`;
  FETCH_FAILED_RESPONSE_LIST = `${this.CONTACT_URL}/${this.fetchPermission}/fail/response/campaignId`;
  DUPLICATE_CAMPAIGN = `${this.url}/${this.campaign}/${this.ADD}/duplicate`;

  retargetedGroup = `${this.CONTACT_URL}/${this.fetchPermission}/retarget/validate/campaign`;
  DOWNLOAD_CAMPAIGN_REPORT = `${this.CONTACT_URL}/${this.fetchPermission}/response/download`;
  CAMPAIGN_PERFORMANCE_DATA = `${this.CONTACT_URL}/${this.fetchPermission}/responsesAnalytics`;
  attachFileUpload = `${this.url}/secure/email/${this.UPLOAD}`;
  updateABTestResultManually = `${this.url}/${this.campaign}/abtest/result/update/manual`;
  convertABTestCampaignToManual = `${this.url}/${this.campaign}/abtest/execution/update/manual`;

  //passkey
  PASSKEY_REGISTER = `${this.SECURE_URI_PATH_TOKEN}/webauthn/register/start`;
  PASSKEY_FINISH_REGISTER = `${this.SECURE_URI_PATH_TOKEN}/webauthn/register/finish`;
  PASSKEY_LOGIN = `${this.PUBLIC_URI_PATH_TOKEN}/webauthn/start`;
  PASSKEY_FINISH_LOGIN = `${this.PUBLIC_URI_PATH_TOKEN}/webauthn/finish`;
  GET_ALL_PASSKEY = `${this.SECURE_URI_PATH_TOKEN}/webauthn/passkeys`;
  DELETE_PASSKEY = `${this.SECURE_URI_PATH_TOKEN}/webauthn/delete/passkey`;
  UPDATE_PASSKEY = `${this.SECURE_URI_PATH_TOKEN}/webauthn/update/passkey`;

  //Unlayer custom tools
  customSocialTool =
    "https://cdn.softsages.com/mailzzy/unlayer-tools/Social.js";
  customVideoTool = "https://cdn.softsages.com/mailzzy/unlayer-tools/Video.js";

  // Discord Webhook frontend url
  webhook_URL = this.PROD
    ? "https://discord.com/api/webhooks/1177478096534908929/Ykq0jiG9LfC8Fb66Ttm5uUeGiA1Hbe8dqxQ8X1EtUBJHEI3sw6HHCqhh11DmLdqYLDzb"
    : "https://discord.com/api/webhooks/1177477956260597881/4XojyhLZiDEXXxXjNPBAknXpFAXgsMtGjW0ioklEAKwJvXDFkABsatolJE6c4Fw8tvrL";
  AUTHENTICATED = `${this.url}/person/authenticated`;

  STRIPE_PUBLIC_KEY = this.PROD
    ? "pk_live_51Jzc0nGMH0qloJSHPOEZr6nMXIlRCzYunReGIIRWJcp5CSaJleYzEpUWkSvd00jcnSeSl2bECFdvxcPy0AkFVNQ100BjvjG2mP"
    : "pk_test_51MjcMuCNqjP1g29JFHvecvJFpGPkHsUAATKm2nTpHxSZWpXnb6TPh9tIcH3Il1odLe16Qyt2I8Nx0ZCfzlui3Cz400lJJGRNIc";
}

let urls = new UrlConstants();
export default urls;
